import Model from '@models/Model'
import UserRole from '@models/UserRole'

class User extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'email',
        'first_name',
        'last_name',
        'avatar_url',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'created_at',
        'updated_at',
      ],
      relationships: {
        user_roles: { collection: true, model: UserRole },
      },
    })
  }
}

export default User
